/** Settings — English, the source of the other languages */
const settings = {
  "settings.mail.sent": "Test email sent to {to} through {host}. Your own mail server is in use from now on.",
  "settings.mail.testFailed": "The test email could not be sent",
  "settings.mail.inUse": "In use: your own mail server.",
  "settings.mail.notYet": "Not in use yet: send a test email to start using your own mail server. Until then mail goes through the platform's mail server.",
  "settings.mail.sendTest": "Send test email",
  "settings.mail.testHint": "Goes to your own address, through the saved settings: save your changes first.",
  "settings.saved": "Settings saved",
  "settings.saveFailed": "Failed to save settings",
  "settings.companySaved": "Company info saved",
  "settings.companySaveFailed": "Failed to save company info",
  "settings.licenseRenewed": "Licence renewed.",
  "settings.licenseInvalid": "Invalid or already used license code",
  "settings.title": "Company settings",
  "settings.save": "Save settings",
  "settings.companyInfo": "Company info",
  "settings.companyName": "Company name",
  "settings.customDomain": "Custom domain",
  "settings.customDomainHint": "The address people sign in at under your own brand. Once it is saved, point its DNS at this platform and prove it is yours with a TXT record (shown here). The HTTPS certificate is arranged by the platform itself.",
  "settings.saveCompany": "Save company info",
  "settings.signIns": "Sign-ins",
  "settings.sessionDays": "Maximum session length (days)",
  "settings.sessionDaysHelp": "After this, everyone in the company signs in again: 1 day to 6 months (183 days), 7 by default. Counted from sign-in; a change also applies to the sessions running now.",
  "settings.idleMax": "Sign out after a time without activity: at most",
  "settings.idleHelp": "A session nobody uses for this long is signed out (8 hours by default). Each person can choose a shorter time under My profile.",
  "settings.idleOffWarning": "Allowing this lets people switch off one of the account protections for this company: a session left open on an unattended computer then stays signed in until it reaches its maximum length.",
  "settings.idleOffQuestion": "Allow people to switch it off?",
  "settings.idleOffLabel": "Let people switch signing out after inactivity off for themselves",
  "settings.syncInterval": "Sync interval",
  "settings.dataPeriod": "Default data period",
  "settings.retention": "Data retention",
  "settings.automation": "Automation & alerts",
  "settings.autoApply": "Auto-apply defaults to new sites",
  "settings.autoApplySub": "Automatically apply the company default template when a site connects",
  "settings.emailAlerts": "Email alerts",
  "settings.emailAlertsSub": "Send alert emails to company admins when sites go offline or critical alerts fire",
  "settings.webhookAlerts": "Webhook alerts",
  "settings.webhookAlertsSub": "POST alert payloads to configured webhook URLs",
  "settings.smtp.title": "Custom email / SMTP",
  "settings.smtp.intro": "Alerts and VPN configuration mails go out through your own mail server, from your own address. Invitations and password resets always come from the platform, so no mail server outside it ever sees a sign-in link. Leave blank to use the platform for everything.",
  "settings.smtp.host": "SMTP host",
  "settings.smtp.userPlaceholder": "you@domain.com",
  "settings.smtp.keepPlaceholder": "(leave blank to keep)",
  "settings.smtp.passwordPlaceholder": "SMTP password",
  "settings.smtp.encrypted": "Encrypted with AES-256 — never returned to browser",
  "settings.smtp.fromEmail": "From email",
  "settings.smtp.fromEmailPlaceholder": "hello@yourcompany.com",
  "settings.smtp.fromName": "From name",
  "settings.overview": "Company overview",
  "settings.slug": "Slug",
  "settings.created": "Created",
  "settings.brandingText": "Customise your platform appearance: colors, logo, app name, fonts, and custom CSS.",
  "settings.openBranding": "Open branding editor →",
  "settings.license": "Licence",
  "settings.expires": "Expires",
  "settings.maxSites": "Max sites",
  "settings.maxUsers": "Max users",
  "settings.renewLicense": "Renew licence",
  "settings.licenseCode": "Licence code",
  "settings.renew": "Renew",
  "settings.more": "More settings",
  "settings.link.branding": "Branding & appearance",
  "settings.link.vpn": "VPN configuration",
  "settings.link.users": "Users & roles",
  "settings.dns.ok": "In place",
  "settings.dns.missing": "Missing",
  "settings.dns.update": "Needs a change",
  "settings.dns.unknown": "Could not check",
  "settings.dns.title": "DNS records for mail from {domain}",
  "settings.dns.freeMail": "{domain} belongs to a mail provider: nobody but that provider can add records there, so receivers may treat this mail as spam. Use an address at your own domain.",
  "settings.dns.addRecords": "Add these TXT records at the DNS provider of {domain}, so receiving mail servers accept the mail instead of marking it as spam.",
  "settings.dns.copyName": "Copy the {type} record name",
  "settings.dns.copyValue": "Copy the {type} record value",
  "settings.dns.now": "Now:",
  "settings.checkNow": "Check now",
  "settings.domain.proven": "Domain proven",
  "settings.domain.serves": "{domain} now serves your dashboard.",
  "settings.domain.notFound": "Not found yet",
  "settings.domain.dnsSlow": "DNS changes can take a while to show up — try again in a few minutes.",
  "settings.domain.checkFailed": "Check failed",
  "settings.domain.ownershipProven": "Ownership proven",
  "settings.domain.ownershipNotYet": "Ownership not proven yet",
  "settings.domain.dnsHere": "DNS points here",
  "settings.domain.dnsNotYet": "DNS does not point here yet",
  "settings.domain.addTxt": "Add this TXT record at your DNS provider. Until it is found, {domain} shows a \"being set up\" page",
  "settings.domain.releaseBefore": "; if it is not found by ",
  "settings.domain.releaseAfter": ", the domain is released from your company",
  "settings.domain.copyName": "Copy the record name",
  "settings.domain.copyValue": "Copy the record value",
  "settings.checked": " · checked {when}",
  "settings.domain.pointA": "Also point an A record for {domain} at {ip}.",
  "settings.domain.thisServer": "this server",
  "settings.sso.saved": "Single sign-on saved",
  "settings.sso.intro": "People sign in with your own identity provider (OpenID Connect: Microsoft Entra ID, Google Workspace, Okta, Keycloak and others). Its multi-factor sign-in replaces ours. Register these sign-in return addresses at the provider:",
  "settings.sso.copy": "Copy {url}",
  "settings.sso.issuer": "Issuer",
  "settings.sso.clientId": "Client ID",
  "settings.sso.clientSecret": "Client secret",
  "settings.sso.secretStored": "Stored — type a new one to replace it",
  "settings.sso.on": "Single sign-on is on",
  "settings.sso.autoJoin": "People of the proven domains join the company on their first sign-in",
  "settings.sso.withRole": "With the role",
  "settings.sso.noRole": "No role (only what everyone may see)",
  "settings.sso.require": "Require single sign-on: no password sign-in for people of the proven domains",
  "settings.sso.breakGlassNote": "Break-glass admins (below) keep their password and two-factor sign-in, for when the identity provider is out of reach.",
  "settings.sso.save": "Save single sign-on",
  "settings.sso.domains": "Domains",
  "settings.sso.domainsIntro": "Prove a domain with a TXT record: its addresses then sign in (and link) without a password",
  "settings.sso.domainsUntil": " — until one is proven, only people who linked from their profile can use single sign-on",
  "settings.sso.proven": "Proven",
  "settings.sso.notProven": "Not proven yet",
  "settings.sso.removeConfirm": "Remove {domain}? Its people can then only sign in with single sign-on after linking it themselves.",
  "settings.sso.domainRemoved": "Domain removed",
  "settings.sso.copyName": "Copy the record name for {domain}",
  "settings.sso.copyValue": "Copy the record value for {domain}",
  "settings.sso.domainAdded": "Domain added",
  "settings.sso.domainToAdd": "Domain to add",
  "settings.sso.addDomain": "Add domain",
  "settings.sso.breakGlass": "Break-glass admins",
  "settings.apikeys.revoked": "API key revoked",
  "settings.apikeys.revokeFailed": "The key could not be revoked",
  "settings.apikeys.copied": "Copied to the clipboard",
  "settings.apikeys.title": "API keys",
  "settings.apikeys.subtitle": "Access to your account for scripts and other systems",
  "settings.apikeys.create": "Create API key",
  "settings.apikeys.createdTitle": "API key created — copy it now",
  "settings.apikeys.createdText": "This is the only time the full key is shown. Store it somewhere safe.",
  "settings.apikeys.hide": "Hide key",
  "settings.apikeys.show": "Show key",
  "settings.apikeys.dismiss": "I have saved it — close",
  "settings.apikeys.prefix": "Prefix",
  "settings.apikeys.permissions": "Permissions",
  "settings.apikeys.lastUsed": "Last used",
  "settings.apikeys.expires": "Expires",
  "settings.apikeys.created": "Created",
  "settings.apikeys.empty": "No API keys yet",
  "settings.apikeys.revokedBadge": "Revoked",
  "settings.apikeys.none": "None",
  "settings.apikeys.never": "Never",
  "settings.apikeys.revokeConfirm": "Revoke \"{name}\"? This cannot be undone.",
  "settings.apikeys.revoke": "Revoke key",
  "settings.apikeys.revokeNamed": "Revoke {name}",
  "settings.apikeys.nameRequired": "A name is required",
  "settings.apikeys.createFailed": "The key could not be created",
  "settings.apikeys.keyName": "Key name *",
  "settings.apikeys.keyNamePlaceholder": "e.g. CI/CD pipeline, monitoring script",
  "settings.apikeys.days30": "30 days",
  "settings.apikeys.days90": "90 days",
  "settings.apikeys.year1": "1 year",
  "settings.apikeys.permHint": "Choose the permissions this key gets. A key needs at least one.",
  "settings.apikeys.createKey": "Create key",
  "settings.branding.resetDone": "Branding reset to the defaults",
  "settings.branding.resetFailed": "Reset failed",
  "settings.branding.saved": "Branding saved",
  "settings.branding.saveFailed": "The branding could not be saved",
  "settings.branding.title": "Branding",
  "settings.branding.subtitle": "The look of the dashboard for your team",
  "settings.branding.resetConfirm": "Reset all branding to the Velanox defaults? This removes every custom colour, font and logo.",
  "settings.branding.reset": "Reset to defaults",
  "settings.branding.save": "Save branding",
  "settings.branding.identity": "Identity",
  "settings.branding.appName": "App name",
  "settings.branding.logoUrl": "Logo URL",
  "settings.branding.faviconUrl": "Favicon URL",
  "settings.branding.loginBanner": "Sign-in banner image",
  "settings.branding.colors": "Colours",
  "settings.branding.color.primaryColor": "Primary",
  "settings.branding.color.secondaryColor": "Secondary",
  "settings.branding.color.accentColor": "Accent",
  "settings.branding.color.backgroundColor": "Background",
  "settings.branding.color.sidebarColor": "Sidebar",
  "settings.branding.color.textColor": "Text",
  "settings.branding.colourOf": "{name} colour",
  "settings.branding.colourCode": "{name} colour code",
  "settings.branding.themeDefault": "theme default",
  "settings.branding.typography": "Typography & shape",
  "settings.branding.font": "Font family",
  "settings.branding.fontDefault": "Platform default (Geist)",
  "settings.branding.radius": "Border radius",
  "settings.branding.radiusDefault": "Platform default",
  "settings.branding.radius.0": "Sharp (0px)",
  "settings.branding.radius.4": "Subtle (4px)",
  "settings.branding.radius.8": "Soft (8px)",
  "settings.branding.radius.12": "Rounded (12px)",
  "settings.branding.radius.16": "Very rounded (16px)",
  "settings.branding.customCss": "Custom CSS",
  "settings.branding.customCssHint": "Advanced: CSS added to every page. At most 50,000 characters.",
  "settings.branding.cssPlaceholder": "/* Custom CSS */",
  "settings.branding.preview": "Live preview",
  "settings.branding.applyPreview": "Apply preview",
  "settings.branding.sampleBadge": "Sample badge",
  "settings.branding.previewHint": "Choose \"Apply preview\" to see the changes live in the sidebar",
  "settings.messages.part.emailSubject": "Email subject",
  "settings.messages.part.emailBody": "Email text",
  "settings.messages.part.whatsappBody": "WhatsApp text",
  "settings.messages.part.rcsBody": "RCS text",
  "settings.messages.wa.approved": "Approved by WhatsApp: your text goes out",
  "settings.messages.wa.rejected": "Rejected by WhatsApp. The default text goes out.",
  "settings.messages.wa.rejectedWhy": "Rejected by WhatsApp: {reason}. The default text goes out.",
  "settings.messages.wa.failed": "Not submitted yet ({reason}). Tried again every 30 minutes; the default text goes out until then.",
  "settings.messages.wa.failedPlain": "Not submitted yet. Tried again every 30 minutes; the default text goes out until then.",
  "settings.messages.wa.paused": "Paused by WhatsApp. The default text goes out.",
  "settings.messages.wa.disabled": "Disabled by WhatsApp. The default text goes out.",
  "settings.messages.wa.pending": "Waiting for WhatsApp's approval (usually within a day). The default text goes out until then.",
  "settings.messages.notChanged": "Not changed",
  "settings.messages.notSaved": "Not saved",
  "settings.messages.tryAgain": "Try again in a moment.",
  "settings.messages.title": "Messages",
  "settings.messages.subtitle": "What your people receive by {channels}. Change the wording, or switch a message off.",
  "settings.messages.channel.email": "email",
  "settings.messages.channels2": "{a} and {b}",
  "settings.messages.channels3": "{a}, {b} and {c}",
  "settings.messages.defaultsPending": "Your own WhatsApp account has not approved the standard texts yet: until it has, WhatsApp messages go out as plain text, which only arrives within 24 hours of the recipient's last message.",
  "settings.messages.variablesInfo": "Words in double braces, like {example}, are filled in when the message is sent. Links come only from the link variables. Invitations and password resets are about security, so they always go out.",
  "settings.messages.noLicence": "Your licence does not include changing messages. You can still put a message back to its default.",
  "settings.messages.sentEmail": "Sent by email",
  "settings.messages.sentWhatsapp": "Sent by WhatsApp",
  "settings.messages.sentRcs": "Sent by RCS",
  "settings.messages.ownWording": "Own wording",
  "settings.messages.alwaysSent": "Always sent",
  "settings.messages.on": "On",
  "settings.messages.off": "Off",
  "settings.messages.sendNamed": "Send \"{label}\"",
  "settings.messages.resetConfirm": "Put \"{label}\" back to the default wording?",
  "settings.messages.resetDone": "Back to the default",
  "settings.messages.ownMeta": "Your own WhatsApp goes through Meta: its texts are the templates named in Company settings → WhatsApp.",
  "settings.messages.twilioOnly": "WhatsApp texts can be changed when the platform sends WhatsApp through Twilio.",
  "settings.messages.waRules": "One paragraph, words before the first variable and after the last, never two variables side by side. A changed text needs WhatsApp's approval before it is used.",
  "settings.messages.rcsNote": "Arrives in the phone's own messages app. Used at once: RCS texts need no approval.",
  "settings.messages.insertVariable": "Insert a variable",
  "settings.messages.example": "Example: {value}",
  "settings.messages.required": "* must stay in the email text",
  "settings.messages.save": "Save",
  "settings.messages.backToDefault": "Back to default",
  "settings.messages.previewRegion": "Preview with example values",
  "settings.messages.preview": "Preview",
  "settings.vpn.downloadFailed": "Download failed",
  "settings.vpn.mayBeCreating": "The VPN file may still be being created.",
  "settings.vpn.creating": "VPN account requested",
  "settings.vpn.creatingText": "Your VPN account is being created. Refresh in 30 seconds.",
  "settings.vpn.createFailed": "The VPN account could not be created",
  "settings.vpn.contactAdmin": "Contact your administrator.",
  "settings.vpn.regenerated": "New VPN file created",
  "settings.vpn.regeneratedText": "Download your new file below.",
  "settings.vpn.regenerateFailed": "No new VPN file could be created",
  "settings.vpn.memberConfirm": "Create a new VPN file for \"{name}\"? The current one stops working.",
  "settings.vpn.memberDone": "VPN account requested",
  "settings.vpn.memberDoneText": "A new VPN file is being created for {name}.",
  "settings.vpn.suspendConfirm": "Suspend the VPN of \"{name}\"?",
  "settings.vpn.enableConfirm": "Turn the VPN of \"{name}\" back on?",
  "settings.vpn.suspended": "VPN suspended",
  "settings.vpn.enabled": "VPN turned on",
  "settings.vpn.notChanged": "Not changed",
  "settings.vpn.siteRegenerated": "New VPN file created for the site",
  "settings.vpn.subtitle": "OpenVPN: a separate network for each company",
  "settings.vpn.mine": "My VPN account",
  "settings.vpn.lastSeen": "Last seen",
  "settings.vpn.download": "Download .ovpn",
  "settings.vpn.regenerateMineConfirm": "Create a new VPN file? Your current .ovpn file stops working.",
  "settings.vpn.regenerateHint": "New file: when the current one is lost or may have been seen by others",
  "settings.vpn.regenerate": "Renew certificate",
  "settings.vpn.suspendedMine": "Your VPN account is suspended. Contact your administrator.",
  "settings.vpn.noAccount": "No VPN account yet.",
  "settings.vpn.createMine": "Create my VPN account",
  "settings.vpn.network": "Company VPN network",
  "settings.vpn.usersNet": "Users network",
  "settings.vpn.sitesNet": "Sites network",
  "settings.vpn.isolation": "Users can reach every site of the company. Sites cannot reach each other.",
  "settings.vpn.networkPending": "The VPN network is being set up…",
  "settings.vpn.all": "All VPN accounts",
  "settings.vpn.count": { one: "{count} account", other: "{count} accounts" },
  "settings.vpn.account": "Account",
  "settings.vpn.type": "Type",
  "settings.vpn.type.USER": "Person",
  "settings.vpn.type.SITE": "Site",
  "settings.vpn.empty": "No VPN accounts yet",
  "settings.vpn.downloadSite": "Download the site's VPN file",
  "settings.vpn.siteConfirm": "Create a new VPN file for \"{name}\"? The current one stops working.",
  "settings.vpn.suspend": "Suspend VPN",
  "settings.vpn.enable": "Turn VPN on",
  "settings.vpn.createFor": "Create VPN account",
  "settings.vpn.setup": "Setup instructions",
  "settings.vpn.tab.personal": "Personal device",
  "settings.vpn.tab.unifi": "UniFi OS (site router)",
  "settings.vpn.pc.1": "Download OpenVPN Connect from https://openvpn.net/client/",
  "settings.vpn.pc.2": "Choose + and then \"Upload File\"",
  "settings.vpn.pc.3": "Select your .ovpn file",
  "settings.vpn.pc.4": "Choose Connect — no username or password needed",
  "settings.vpn.pc.note": "OpenVPN Connect 3.x is required. The older OpenVPN GUI also works.",
  "settings.vpn.linux.1": "Install: sudo apt install openvpn (or the equivalent for your distribution)",
  "settings.vpn.linux.2": "Connect: sudo openvpn --config your-name.ovpn",
  "settings.vpn.linux.3": "Or use NetworkManager: import the .ovpn file through the network menu",
  "settings.vpn.ios.1": "Install \"OpenVPN Connect\" from the App Store",
  "settings.vpn.ios.2": "Send the .ovpn file to your device by AirDrop or email",
  "settings.vpn.ios.3": "Choose \"Open with OpenVPN Connect\" when asked",
  "settings.vpn.ios.4": "Choose Add and then Connect",
  "settings.vpn.android.1": "Install \"OpenVPN Connect\" from the Play Store",
  "settings.vpn.android.2": "Share the .ovpn file with OpenVPN Connect",
  "settings.vpn.android.3": "Choose Import and then Connect",
  "settings.vpn.security": "Security:",
  "settings.vpn.securityText": "Keep your .ovpn file private: it is your personal access. If it is lost or may have been seen by others, create a new file above; the old one then stops working.",
  "settings.webhooks.event.site.offline": "Site offline",
  "settings.webhooks.event.site.online": "Site back online",
  "settings.webhooks.event.alert.critical": "Critical alerts",
  "settings.webhooks.event.alert.error": "Error alerts",
  "settings.webhooks.event.alert.warning": "Warnings",
  "settings.webhooks.event.alert.info": "Information",
  "settings.webhooks.event.license.expiring": "Licence expiring",
  "settings.webhooks.deleted": "Webhook deleted",
  "settings.webhooks.deleteFailed": "The webhook could not be deleted",
  "settings.webhooks.toggleFailed": "The webhook could not be switched",
  "settings.webhooks.testDelivered": "Test delivered",
  "settings.webhooks.answered": "Your endpoint answered {code}.",
  "settings.webhooks.testFailed": "Test failed",
  "settings.webhooks.noResponse": "No response",
  "settings.webhooks.unreachable": "Check that the webhook URL can be reached and answers with a 2xx status.",
  "settings.webhooks.title": "Webhooks",
  "settings.webhooks.subtitle": "Events sent to your own systems as they happen, by HTTP POST",
  "settings.webhooks.add": "Add webhook",
  "settings.webhooks.eventsLabel": "Events:",
  "settings.webhooks.info": "Each webhook receives the events chosen for it (all of them when none are chosen). Payloads are signed with HMAC-SHA256 using your webhook secret.",
  "settings.webhooks.events": "Events",
  "settings.webhooks.updated": "Last updated",
  "settings.webhooks.empty": "No webhooks yet",
  "settings.webhooks.allEvents": "All events",
  "settings.webhooks.disable": "Switch off",
  "settings.webhooks.enable": "Switch on",
  "settings.webhooks.sendTest": "Send test event",
  "settings.webhooks.edit": "Edit",
  "settings.webhooks.deleteConfirm": "Delete webhook \"{name}\"?",
  "settings.webhooks.nameRequired": "A name is required",
  "settings.webhooks.urlRequired": "A URL is required",
  "settings.webhooks.saveFailed": "The webhook could not be saved",
  "settings.webhooks.editTitle": "Edit webhook",
  "settings.webhooks.name": "Name *",
  "settings.webhooks.namePlaceholder": "My webhook",
  "settings.webhooks.secret": "Secret",
  "settings.webhooks.secretKeep": "(leave empty to keep the current one)",
  "settings.webhooks.secretRecommended": "(recommended)",
  "settings.webhooks.secretPlaceholder": "Optional secret for the HMAC signature",
  "settings.webhooks.signed": "When set, every payload is signed in this header:",
  "settings.webhooks.noneChosen": "(none chosen: all of them)",
  "settings.webhooks.saveChanges": "Save changes",
  "settings.messages.who": "Who gets this text",
  "settings.messages.who.everyone": "Everyone, whatever their language",
  "settings.messages.who.perLanguage": "Per language — others get the default text in their language",
  "settings.messages.language": "Language",
  "settings.messages.hasOwnText": "has its own text",
  "settings.messages.everyoneHint": "Written once, sent to everyone as it is. Parts you leave unchanged follow each person’s language.",
  "settings.messages.languageHint": "People who read {language} get this text; the default text in {language} is shown until you change it.",
  "settings.messages.removeLanguage": "Remove the {language} text",
  "settings.messages.removeLanguageConfirm": "Remove the {language} text of “{label}”? People who read {language} get the default text.",
  "settings.messages.removed": "Text removed",
  "settings.tabs": "Settings sections",
  "settings.tab.general": "General",
  "settings.tab.security": "Security",
  "settings.tab.monitoring": "Monitoring & alerts",
  "settings.tab.messaging": "Messaging",
  "settings.tab.licence": "Licence",
  "settings.unsaved": "unsaved changes",
  "settings.languageTime": "Language and time zone",
  "settings.messaging.none": "Your licence includes no own mail server, WhatsApp or RCS: messages go out through the platform.",
  "settings.logo.title": "Logo",
  "settings.logo.alt": "Logo of {name}",
  "settings.logo.hint": "Shows the company where you choose it after signing in, and in lists. Any picture (PNG, JPEG, WebP, GIF, SVG, AVIF…), up to 10 MB; it is scaled to 256 × 256.",
  "settings.logo.choose": "Choose picture",
  "settings.logo.change": "Change picture",
  "settings.logo.remove": "Remove logo",
  "settings.logo.removeConfirm": "Remove the logo of {name}?",
  "settings.logo.saved": "Logo saved",
  "settings.logo.removed": "Logo removed",
  "settings.logo.notSaved": "Logo not saved",
  "settings.logo.wrongType": "Choose an image file",
  "settings.logo.tooLarge": "The picture is larger than 10 MB",
  "settings.logo.unreadable": "This browser cannot open this picture: save it as PNG or JPEG and try again",
  "settings.banner.title": "Banner logo",
  "settings.banner.hint": "Shown in the middle of the top bar instead of the company's name. A wide picture, any kind (PNG, JPEG, WebP, GIF, SVG, AVIF…), up to 10 MB.",
  "settings.banner.remove": "Remove banner logo",
  "settings.banner.removeConfirm": "Remove the banner logo of {name}?",
  "settings.banner.saved": "Banner logo saved",
  "settings.banner.removed": "Banner logo removed",
  "settings.banner.notSaved": "Banner logo not saved",
  "settings.tab.rental": "Rental",
  "settings.tab.connections": "Connections",
  "settings.connections.intro": "The controllers your sites are reached through. Each is checked when it is saved; a secret is never shown again.",
  "settings.connections.none": "No connections yet: add one from the Sites page.",
  "settings.connections.saved": "Connection saved",
  "settings.connections.saveFailed": "Could not save the connection",
  "settings.connections.deleted": "Connection deleted",
  "settings.connections.deleteFailed": "Could not delete the connection",
  "settings.connections.sites": { one: "{count} site", other: "{count} sites" },
  "settings.connections.checked": "checked {when}",
  "settings.connections.waiting": "Waiting for the controller's VPN connection: download its .ovpn and start it on the controller's computer.",
  "settings.connections.save": "Save",
  "settings.connections.addSites": "Add sites",
  "settings.connections.edit": "Edit",
  "settings.connections.deleteConfirm": "Delete the connection {name}?",
  "settings.connections.newCert": "New certificate",
  "settings.connections.newCertDone": "New certificate issued: download the .ovpn and start it on the controller's computer",
  "settings.connections.newCertFailed": "Could not issue a new certificate",
  "settings.phonesStay": "Phones may stay signed in (the mobile app, opened with Face ID or a fingerprint)",
  "settings.phonesStayHelp": "The inactivity limit above still counts time in the app; after it, the phone asks for Face ID again.",
  "settings.phonesOffConfirm": "Turn this off? When saved, every phone of the company is signed out and asks for the password again.",
  "settings.messages.part.pushTitle": "Push title",
  "settings.messages.part.pushBody": "Push text",
  "settings.messages.sentPush": "Sent by push (phone app)",
  "settings.messages.pushNote": "Shown on the phone's lock screen under the Velanox app's name; at most 100 and 500 characters.",
  "settings.messages.pushPreview": "Velanox app · push",
  "settings.simPins.title": "SIM cards",
  "settings.simPins.help": "The company PIN for the SIMs in Teltonika routers, and the SIMs with a PIN of their own. PINs show as dots; Show asks for your password and is logged.",
  "settings.simPins.companyPin": "Company PIN",
  "settings.simPins.notSet": "Not set",
  "settings.simPins.set": "Set",
  "settings.simPins.save": "Save",
  "settings.simPins.newCompanyPin": "New company PIN (4 to 8 digits)",
  "settings.simPins.changeHelp": "SIMs already locked with the current company PIN keep it as their own PIN.",
  "settings.simPins.show": "Show",
  "settings.simPins.ownPins": "SIMs with their own PIN",
  "settings.simPins.noOwn": "None yet.",
  "settings.simPins.removeConfirm": "Forget the PIN of SIM {iccid}?",
  "settings.simPins.notShown": "The PIN was not shown",
  "settings.simPins.notSaved": "Not saved",
  "settings.simPins.removeNoteConfirm": "Forget the note of SIM {iccid}? It stays on the company PIN.",
  "settings.pushFirst.title": "Push first",
  "settings.pushFirst.companyIntro": "Applies to this company's own WhatsApp and RCS.",
  "settings.pushFirst.on": "Push goes first",
  "settings.pushFirst.onHelp": "An alert goes by push to people with the app; WhatsApp or RCS follow only when it was not seen within the wait.",
  "settings.pushFirst.wait": "Wait before WhatsApp or RCS (minutes)",
  "settings.pushFirst.waitRange": "1 to 60 whole minutes",
  "settings.pushFirst.anyone": "Skip WhatsApp and RCS once anyone has seen it",
  "settings.pushFirst.anyoneHelp": "A colleague opening the site counts for everyone told about it.",
  "settings.pushFirst.save": "Save",
  "settings.backdrop.dark": "Backdrop in dark mode",
  "settings.backdrop.light": "Backdrop in light mode",
  "settings.backdrop.none": "None",
  "settings.backdrop.default.dark": "Warm white",
  "settings.backdrop.default.light": "Dashboard dark",
  "settings.backdrop.own": "Own colour",
  "settings.backdrop.colour.dark": "Backdrop colour in dark mode",
  "settings.backdrop.colour.light": "Backdrop colour in light mode",
  "settings.backdrop.saved": "Backdrop saved",
  "settings.backdrop.notSaved": "Backdrop not saved",
  "settings.backdrop.help": "For a picture that disappears in one theme: a light backdrop behind dark letters, a dark one behind light letters.",
}

export default settings
